"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconStyles = _styledComponents["default"].span.withConfig({
  componentId: "sc-1x8piyt-0"
})(["svg path{fill:", ";}"], function (props) {
  return props.color;
});

var _default = IconStyles;
exports["default"] = _default;